import { render, staticRenderFns } from "./SalesOrderStatusRefunds.vue?vue&type=template&id=2b1e6d43&"
import script from "./SalesOrderStatusRefunds.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusRefunds.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusRefunds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports